const typography = {
  fontFamily: "Cairo, sans-serif",
  textAlign: "right",
  h1: {
    fontWeight: 500,
    fontSize: 38,
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
  },
  overline: {
    fontWeight: 500,
  },
  body1: {
    fontSize: 16,
  },
  body2: {
    fontSize: 14,
  },
};

export default typography;
